export const SWITCH_BAR_CLICKED = 'SWITCH_BAR_CLICKED'



// WEBPACK FOOTER //
// app/javascript/sg/js/constants.js